import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeSetLikeMarker, meshGeometryAttributeSetLike} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeSetLikeNode, CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {BoundaryOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/boundary-operator/geometry-boundary-operator-node"
import {
    GeometryBoundaryOperatorNode,
    boundaryOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/boundary-operator/geometry-boundary-operator-node"

export type CurveGeometryBoundaryOperatorParameters = BoundaryOperatorParameters<MeshGeometryAttributeLikeNode, MeshGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryBoundaryOperatorParameters> = {
    nodeClass: "CurveGeometryBoundaryOperator",
    validation: {
        parameters: boundaryOperatorParametersSchema(meshGeometryAttributeLike, meshGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryBoundaryOperator
    extends GeometryBoundaryOperatorNode<2, MeshGeometryAttributeLikeNode, MeshGeometryAttributeSetLikeNode>
    implements CurveGeometryAttributeSetLikeNode
{
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
